import api from './api'
import { DashboardResumo, RankingProprio } from '@/types/dashboard'

export const dashboardService = {
  // O backend (oportunidades-service /v1/dashboard/resumo) devolve o objeto puro
  // — sem envelope ApiResponse. O response interceptor já entrega o body, então
  // basta retorná-lo diretamente.
  /**
   * `canal` (decisão 6.7): recorta os agregados por canal comercial — só o back-office;
   * o backend ignora o parâmetro para consultor. 'SEM_CANAL' = reservas anteriores ao
   * carimbo.
   */
  /**
   * `periodo` (L13): `inicio`/`fim` ISO, inclusivos — o backend recorta funil, volume por
   * etapa e indicadores de volume. Ausente = sem recorte (a carteira inteira).
   */
  getResumo: async (
    canal?: string,
    periodo?: { inicio: string; fim: string } | null
  ): Promise<DashboardResumo> => {
    const params = new URLSearchParams()
    if (canal) params.set('canal', canal)
    if (periodo) {
      params.set('inicio', periodo.inicio)
      params.set('fim', periodo.fim)
    }
    const query = params.toString() ? `?${params.toString()}` : ''
    return await api.get<DashboardResumo>(`/api/v1/dashboard/resumo${query}`)
  },

  /**
   * Posição do próprio consultor no ranking por volume ganho (VC-04, AN-5 §3.2). Sem
   * parâmetro de consultor — o backend usa o `sub` do token. 403 para quem não é
   * consultor (`RANKING_SO_CONSULTOR`); a tela esconde o card em 403/404.
   */
  getRankingProprio: async (): Promise<RankingProprio> => {
    return await api.get<RankingProprio>('/api/v1/dashboard/ranking-proprio')
  },
}
